/**
 * Onboarding-specific feature flags.
 *
 * These are resolved through the platform feature-gate system
 * (environment variable DEFAULT_FEATURE_SWITCHES or query string ?setGateValue=).
 * Names are case-insensitive at runtime; the values here are the canonical casing.
 */
export const FeatureFlags = {
  EnableDeviceOrderingAddresses: "enabledeviceorderingaddresses",
  EnableHubSupportCases: "enablehubsupportcases",
  EnableHubSupportAssistant: "enablehubsupportassistant",
  EnableHubCaseEmailReply: "enablehubcaseemailreply",
  EnableTestConsole: "enabletestconsole",
} as const;

export type FeatureFlag = (typeof FeatureFlags)[keyof typeof FeatureFlags];
